module.exports = __webpack_public_path__ + "img/36个核心功能模块.6ad89443.png";